/** Display helpers for the selection flow. `todayISO` / `formatDisplayDate` are
 * shared with the contract page (the same signing-date semantics). */
export { todayISO, formatDisplayDate } from '../contract/format';

/** A monthly premium as `$612.40`. */
export function money(amount: number): string {
  return `$${amount.toFixed(2)}`;
}
